module.exports = __webpack_public_path__ + "static/media/gcdef_10022.f11a6dda.ico";